<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="row" style="padding: 5px">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--Menu Bar-->
				<div class="lock-to-top" style="background-color: #ffffff">
					<!--Buttons-->
					<div class="button-body flex">
						<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

						<!--INSERT CUSTOM BUTTONS HERE-->
						<button class="btn btn-primary" style="margin-left: 5px" (click)="onAssignLocker()">Assign Locker</button>
						<button [disabled]="EnableEdit() == false" class="btn btn-primary" style="margin-left: 5px" (click)="onEditAssignment()">
							Edit Assignment
						</button>
						<button [disabled]="EnableEdit() == false" class="btn btn-primary" style="margin-left: 5px" (click)="onUnassignLocker()">
							Unassign Locker
						</button>
					</div>
				</div>

				<!--Table-->
				<div class="table-main-body">
					<p-table
						#mydt
						[value]="lstLockerPerson"
						[loading]="loading"
						[paginator]="true"
						[(rows)]="pagerows"
						[(first)]="pagefirst"
						[showCurrentPageReport]="true"
						[resizableColumns]="false"
						sortMode="multiple"
						styleClass="p-datatable-striped"
						selectionMode="single"
						[(selection)]="SelectedLockerPerson"
						dataKey="LockerPersonID"
						(onFilter)="onHandleFilter($event)"
						(onSort)="onHandleSort($event)"
						(onRowSelect)="onRowSelect($event)"
						(onRowUnselect)="onRowUnselect($event)"
						currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
						[rowsPerPageOptions]="[5, 10, 25, 50]"
					>
						<!--Headers-->
						<ng-template pTemplate="header">
							<!--Filter or Select from Dropdown-->
							<tr>
								<!--INSERT CUSTOM FILTERS HERE-->

								<!--LockerNum-->
								<th>
									<p-columnFilter type="text" field="LockerNum" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--LockerComment-->
								<th>
									<p-columnFilter type="text" field="AssignmentComments" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--MoveInDateDesc-->
								<th>
									<!-- <p-columnFilter type="text" field="MoveInDateDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--MoveOutDateDesc-->
								<th>
									<!-- <p-columnFilter type="text" field="MoveOutDateDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--Comments-->
								<th>
									<p-columnFilter type="text" field="Comments" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--AssignedDesc-->
								<th>
									<p-columnFilter field="AssignedDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterAssignedDesc
												[ngModel]="value"
												[options]="lstAssignedDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>
							</tr>

							<!--Column Names-->
							<tr style="height: 4rem">
								<!--INSERT CUSTOM COLUMNS HERE-->
								<th pSortableColumn="LockerNum">Locker Number<p-sortIcon field="LockerNum"></p-sortIcon></th>
								<th pSortableColumn="LockerComment">Locker Comment/Combination<p-sortIcon field="LockerComment"></p-sortIcon></th>
								<th pSortableColumn="MoveInDate">Move In<p-sortIcon field="MoveInDate"></p-sortIcon></th>
								<th pSortableColumn="MoveOutDate">Move Out<p-sortIcon field="MoveOutDate"></p-sortIcon></th>
								<th pSortableColumn="AssignmentComments">Comments<p-sortIcon field="AssignmentComments"></p-sortIcon></th>
								<th pSortableColumn="AssignedDesc">Active<p-sortIcon field="AssignedDesc"></p-sortIcon></th>
							</tr>
						</ng-template>

						<!--Data-->
						<ng-template pTemplate="body" let-LockerPerson>
							<tr [pSelectableRow]="LockerPerson" (dblclick)="onRowDblClick(LockerPerson)">
								<td *ngFor="let col of cols" style="font-weight: bold">
									{{ LockerPerson[col.field] }}
								</td>
							</tr>
						</ng-template>
					</p-table>
				</div>

				<!--Error Message-->
				<div class="TopMargin">
					<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
						{{ errorMessage }}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
